import React, { useEffect, useState } from 'react';
import { Field, FieldArray } from 'redux-form';
import { renderNumeroSinFormato, renderFieldDisabled, AsyncSelectField, SelectFieldAllFields, renderDollar } from '../../../../Utils/renderField/renderField';
import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import { api } from "api";
import { months } from '../../../../Utils/months';


const TableRow = ({ system, index, fields, change }) => {
    const isNew = fields.get(index).isNew;


    const fetchData = (endpoint, params) => {
        return api.get(endpoint, params)
            .then((data) => {
                if (data) return data.results;
                return [];
            })
            .catch(() => {
                return [];
            });
    };

    const getCustomers = (search) => {
        return fetchData("customer", { search });
    };

    const getPort = (search) => {
        return fetchData("port", { search });
    };

    const getTransport = (search) => {
        return fetchData("transport", { search });
    };

    const [packingOptions, setPackingOptions] = useState([]);

    const filtroPacking = (id) => {
        api.get("packing/get_packing", { id })
            .then((data) => {
                if (data) {
                    const options = data.map(packing => ({
                        id: packing.id,
                        name: packing.name,
                        storage_capacity: packing.storage_capacity
                    }));
                    setPackingOptions(options);
                }
            })
            .catch((error) => {
                console.error("Error fetching packings:", error);
            });
    };

    // Recetea el estado de packing para que tenga el valor
    //  en 0 y asi no se sumen si no se tiene seleccionado ninguno
    const [firstRender, setFirstRender] = useState(true);

    useEffect(() => {
        if (!firstRender) {
            change(`${system}.packing`, null);
        } else {
            setFirstRender(false);
        }
    }, [packingOptions]);


    const calculateTotalForRow = () => {
        const systemData = fields.get(index);
        if (!systemData) return 0;

        const totalForRow = months.reduce((accumulatedTotal, month) => {
            const value = parseFloat(systemData[month]) || 0;
            accumulatedTotal += value;
            return accumulatedTotal;
        }, 0);

        return totalForRow;
    };


    return (
        <React.Fragment key={index}>
            <tr key={`system-${index}`}>
                <td className="cell-cliente" style={{ position: 'relative' }}>
                    <Field
                        name={isNew ? `${system}.customer` : `${system}.customer.company`}
                        component={isNew ? AsyncSelectField : renderFieldDisabled}
                        loadOptions={getCustomers}
                        valueKey="id"
                        labelKey="company"
                        className="form-control"
                    />
                </td>
                <td className="cell-puerto">
                    <Field
                        name={isNew ? `${system}.depure_port` : `${system}.depure_port.name`}
                        component={isNew ? AsyncSelectField : renderFieldDisabled}
                        loadOptions={getPort}
                        valueKey="id"
                        labelKey="name"
                        className="form-control"
                    />
                </td>
                <td className="cell-transporte">
                    <Field
                        name={isNew ? `${system}.type_of_transport` : `${system}.type_of_transport.name`}
                        component={isNew ? AsyncSelectField : renderFieldDisabled}
                        loadOptions={getTransport}
                        valueKey="id"
                        labelKey="name"
                        className="form-control"
                        onChange={e => filtroPacking(e ? e.id : -1)}
                    />  
                </td>
                <td className="cell-empaque border-top">
                    <Field
                        name={isNew ? `${system}.packing` : `${system}.packing.name`}
                        component={isNew ? SelectFieldAllFields : renderFieldDisabled}
                        options={packingOptions}
                        valueKey="id"
                        labelKey="name"
                        className="form-control"
                    />
                </td>
                <td className="cell-diferencial">
                    <Field
                        name={`${system}.differential`}
                        decimalScale={4}
                        component={renderDollar}
                        className="form-control"
                        placeholder="$ 0.00"
                    />
                </td>
                {months.map((month) => (
                    <td key={month} className="cell-mes">
                        <Field
                            name={`${system}.${month}`}
                            type="text"
                            component={renderNumeroSinFormato}
                            className="form-control"
                            placeholder="0.0"
                            style={{ 
                                height: "45px", 
                                minHeight: "45px", 
                                fontSize: "16px",
                                padding: "8px 12px",
                                width: "100%"
                            }}
                        />
                    </td>
                ))}
                <td className="cell-total text-right-padded">
                    {new Intl.NumberFormat('es-GT', { style: 'decimal',
                        maximumFractionDigits: 2,
                        minimumFractionDigits: 2
                     }).format(calculateTotalForRow())}
                </td>
                <td className="cell-action">
                    <div style={{ display: 'flex' }}>
                        <div>
                            <img src={require('assets/img/icons/Accion-Eliminar.svg')} alt="Borrar"
                                title="Borrar" className="action_img"
                                onClick={() => {
                                    fields.remove(index)
                                }}
                            />
                        </div>
                    </div>
                </td>
            </tr>
        </React.Fragment>
    );
};

const GenericTable = ({ fields, change }) => {

    const calculateTotalForMonth = (month) => {
        const allFields = fields.getAll() || [];
        const total = allFields.reduce((accumulatedTotal, system) => {

            const value = parseFloat(system[month]) || 0;
            accumulatedTotal += value
            return accumulatedTotal;
        }, 0);

        return total;
    };
    const columnas = months.map((_, idx) =>(
        <th style={{ width: "4.66%" }} key={idx}>{idx + 1}</th>
    ))

    return (
        <div className=" col-sm-12 form-group np-r p-0">
            <div className="table-responsive">
                <table className="table table-striped mb-0 text-center">
                    <thead>
                            <tr>
                                <th className="cell-cliente titulo-left-padded">CLIENTE</th>
                                <th className="cell-puerto titulo-left-padded">PUERTO DE SALIDA</th>
                                <th className="cell-transporte titulo-left-padded">TRANSPORTE</th>
                                <th className="cell-empaque titulo-left-padded">EMPAQUE</th>
                                <th className="cell-diferencial titulo-left-padded">DIFERENCIAL</th>
                                {columnas}
                                <th className="cell-total text-right-padded">TOTAL</th>
                                <th className="cell-action"></th>
                            </tr>
                        </thead>
                        <tbody >
                            {fields.map((system, index) => <TableRow key={index} system={system} index={index} fields={fields} change={change} />)}
                            <tr style={{ backgroundColor: "#F0FFC7", borderTop: '1px solid #035B2F' }}>
                                <td className="custom-cell text-center"></td>
                                <td className="custom-cell text-center"></td>
                                <td className="custom-cell text-center"></td>
                                <td className="custom-cell text-center"></td>
                                <td className="custom-cell text-center"></td>
                                {months.map((month, idx) => (
                                    <td key={idx} className="custom-cell text-right-padded">
                                        {new Intl.NumberFormat('es-GT', { style: 'decimal',
                                            maximumFractionDigits: 2,
                                            minimumFractionDigits: 2
                                        }).format(calculateTotalForMonth(month))}
                                    </td>
                                ))}
                                <td className="custom-cell text-center"></td>
                                <td className="custom-cell text-center"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>


            <div className="mt-2">
                <div type="button" className="btn btn-light btn-lg btn-block d-flex justify-content-end agregar-tab-generica" onClick={() => fields.push({ isNew: true })}>
                    AGREGAR
                </div>
            </div>
        </div>
    );
}

const SalesTable = ({ fieldName, allValues, change }) => {
    return (
        <div className="table-container-fixed">
            <FieldArray
                name={`${fieldName}`}
                component={GenericTable}
                allValues={allValues}
                change={change}
            />
        </div>
    );
}

const formName = 'SalesTable';

const selector = formValueSelector(formName);

const mapStateToProps = (state) => {
    const row_sales = selector(state, 'generic_row_sales') || [];
    const allValues = row_sales.map(item => item);
    return { allValues };
};

export default connect(mapStateToProps)(SalesTable);